import React from 'react';
import classnames from 'classnames';
import ClearIcon from '../ClearIcon';
import styles from './styles.module.scss';
import inputStyles from '../../styles/commonInput.module.scss';

const FilterText = ({
                      containerClassnames = '',
                      labelClassnames = '',
                      inputClassnames = '',
                      placeholder,
                      value,
                      fieldName,
                      type = 'text',
                      setFieldValue,
                      handleSubmit,
                      handleBlur,
                      formatValue,
                      ...rest
                    }) => {

  return (
    <div className={classnames(styles.container, containerClassnames)}>
      {value && <div className={classnames(styles.label, labelClassnames)}>{placeholder}</div>}
      <input
        type={type}
        className={classnames(inputStyles.input, 'pl-4', inputClassnames)}
        name={fieldName}
        placeholder={placeholder}
        onBlur={handleBlur}
        value={value}
        onChange={(e) => {
          if (formatValue) {
            setFieldValue(fieldName, formatValue(e));
          } else {
            setFieldValue(fieldName, e.target.value);
          }
          handleSubmit();
        }}
        {...rest}
      />
      <ClearIcon
        onClick={() => {
          setFieldValue(fieldName, '');
          handleSubmit();
        }}
      />
    </div>
  );
};

export default FilterText;
